
export const TYPE_MANUFACTURER = 'manufacturer';

export const TYPE_VENDOR = 'vendor';



// WEBPACK FOOTER //
// ./src/utils/plans.js